import * as CharacteristicsActions from "./characteristics.actions";

import {createReducer, on} from "@ngrx/store";
import {DahLoadingType} from '@common/components-module/core-components.models';
import {Characteristics} from '@association/_common/models/characteristics.models';
import {SetAllInitialStates} from '@common/store/actions/core.actions';

export const characteristicFeatureKey = 'characteristic';

export interface CharacteristicState {
    listLoading: DahLoadingType,
    characteristics?: Characteristics
}

export const initialState: CharacteristicState = {
    listLoading: 'listLoading'
};

export const characteristicReducer = createReducer(
    initialState,

    on(CharacteristicsActions.LoadList, (state) => ({
        ...state,
        // @ts-ignore
        listLoading: state.characteristics ? undefined : 'listLoading'
    })),

    on(CharacteristicsActions.LoadListSuccess, (state, action) => ({
        ...state,
        listLoading: undefined,
        characteristics: action.payload
    })),

    on(CharacteristicsActions.LoadListFailure, (state) => ({
        ...state,
        listLoading: undefined
    })),

    on(CharacteristicsActions.SetInitialState, SetAllInitialStates, () => ({...initialState}))
);
